import { getAnalyticsWebClientPromise } from '@atlassian/help-center-common-util/analytics/client';
import { getMeta } from '@atlassian/help-center-common-util/meta';
import { init } from '@atlassian/ufo-interaction-metrics-init';
import traceUFOPageLoad from '@atlassian/ufo-trace-pageload';

export const initUFO = () => {
    init(
        Promise.resolve({
            getAnalyticsWebClientPromise,
        }),
        {
            product: 'jira',
            enableCompleteUsingDoubleRAF: true,
            region: getMeta('ajs-region') || 'unknown', //TODO:SSR and FF data
            namePrefix: 'help-center-ufo-',
            vc: {
                enabled: true,
                selectorConfig: {
                    className: false,
                    role: false,
                    id: false,
                    testId: false,
                },
            },
            kind: {
                /*
                 * Sampling works in 1 in the rate specified.
                 * If rate is 1, it captures all events - 1/1
                 */
                page_load: 1,
                transition: 1,
                press: 1,
                typing: 1,
                legacy: 0, //For some Jira events that will be cleaned up in UFO
                hover: 1,
            },
        }
    );
    /*
     * Start instrumenting the page load event.
     * We invoke `traceUFOPageLoad` once more
     * when we have the route context.
     * It attaches the route name to the event.
     * */
    traceUFOPageLoad();
};
